const Documentation = () => {
  const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

  return (
    <div className="space-y-6">
      {/* Endpoint Info */}
      <div className="bg-[#1a1a1a] border border-gray-800 rounded-lg p-4 lg:p-6">
        <h2 className="text-lg font-bold text-white mb-4">Endpoint</h2>
        <div className="space-y-2">
          <div className="flex items-start gap-2">
            <span className="px-2 py-1 bg-green-600 text-white text-xs font-bold rounded flex-shrink-0">POST</span>
            <code className="text-blue-400 text-xs lg:text-sm break-all">{BACKEND_URL}/api/gmail/automate</code>
          </div>
          <p className="text-sm text-gray-400 mt-2">Endpoint público (sem autenticação)</p>
        </div>
      </div>

      {/* Example */}
      <div className="bg-[#1a1a1a] border border-gray-800 rounded-lg p-4 lg:p-6">
        <h2 className="text-lg font-bold text-white mb-4">Exemplo de Requisição</h2>
        
        <div className="space-y-4">
          {/* cURL Example */}
          <div>
            <h3 className="text-sm font-bold text-gray-300 mb-2">cURL</h3>
            <div className="bg-gray-900 rounded-lg p-3 lg:p-4 overflow-x-auto">
              <pre className="text-xs lg:text-sm text-gray-300 font-mono whitespace-pre-wrap break-all">
{`curl -X POST "${BACKEND_URL}/api/gmail/automate" \\
  -H "Content-Type: application/json" \\
  -d '{"email": "usuario@gmail.com"}'`}
              </pre>
            </div>
          </div>

          {/* Response */}
          <div>
            <h3 className="text-sm font-bold text-gray-300 mb-2">Resposta</h3>
            <div className="bg-gray-900 rounded-lg p-3 lg:p-4 overflow-x-auto">
              <pre className="text-xs lg:text-sm text-green-400 font-mono">
{`{
  "id": "550e8400-e29b-41d4-a716-446655440000",
  "email": "usuario@gmail.com",
  "id_google": "123456789012345678",
  "nome": "João da Silva",
  "profile_picture": "https://lh3.googleusercontent.com/...",
  "dados_google": [...],
  "success": true,
  "timestamp": "2025-01-23T22:15:30.123Z"
}`}
              </pre>
            </div>
            <p className="text-xs text-gray-500 mt-2">
              <strong>dados_google:</strong> Array contendo informações detalhadas do perfil Google Local Guides (reviews, fotos, estatísticas, etc.)
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Documentation;
